type TokenExpiredError = {
  networkError?: {
    statusCode?: number;
  };
  graphQLErrors?: Array<{
    extensions?: {
      code?: string;
    };
  }>;
};

const isTokenExpiredError = (error: unknown): boolean => {
  const typedError = error as TokenExpiredError;

  // Check for 401 Unauthorized error
  if (
    typedError?.networkError?.statusCode === 401 ||
    typedError?.graphQLErrors?.[0]?.extensions?.code === 'UNAUTHENTICATED'
  ) {
    return true;
  }
  return false;
};

export default isTokenExpiredError;
